const __IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const getFaviconFallback = () =>
  __IS_DEVELOPMENT
    ? require("assets/images/favicon.dev.png")
    : require("assets/images/favicon.png");
